$(function () {
    let searchBtnAction = $(".search-btn");
    searchBtnAction.each(function () {
        $(this).on("click", function () {
            setTimeout(function () {
                document.getElementsByName('locality')[0].focus();
            }, 10);
            document.getElementsByName('locality')[0].classList.toggle('dark');
            setTimeout(function () {
                document.getElementsByName('locality')[0].classList.toggle('dark');
            }, 200);
            setTimeout(function () {
                document.getElementsByName('locality')[0].classList.toggle('dark');
            }, 400);
            setTimeout(function () {
                document.getElementsByName('locality')[0].classList.toggle('dark');
            }, 600);
            setTimeout(function () {
                document.getElementsByName('locality')[0].classList.toggle('dark');
            }, 800);
            setTimeout(function () {
                document.getElementsByName('locality')[0].classList.toggle('dark');
            }, 1000);
        });
    });

    let userAccountButton = $("#user-account");
    userAccountButton.on("click", function () {
        app.togglePopup();
    });

});



// WEBPACK FOOTER //
// ./src/Resources/assets/js/UI/rp-navbar.js